import { GridAction } from '@eforall/dashboard';
import { AlignedCommitment } from '../aligned-commitments.part';

export function getActions() {

	const actions: GridAction<AlignedCommitment>[] = [
	];

	return actions;
}